module.exports = __webpack_public_path__ + "img/fire-flame-simple.54fe8282.svg";